import { cn } from '@/lib/utils'
import WishLegacyPriority from 'app/frontend/types/custom/WishLegacyPriority'

const priorityBackgroundByLevel: Record<WishLegacyPriority, string> = {
  huge: 'bg-destructive-foreground',
  big: 'bg-warning-foreground',
  small: 'bg-success-foreground',
  tiny: 'bg-muted-foreground',
  none: 'bg-transparent',
}

type Props = {
  priority: WishLegacyPriority
  className?: string
}

const WishLegacyPriorityDot = ({ priority, className }: Props) => {
  return (
    <div
      className={cn(
        'w-2.5 h-2.5 border border-accent min-w-2.5 min-h-2.5 rounded-full',
        priorityBackgroundByLevel[priority],
        className,
      )}
    />
  )
}

export default WishLegacyPriorityDot
